import React from 'react';
import { Helmet } from 'react-helmet';
import { FaTicketAlt, FaExternalLinkAlt } from 'react-icons/fa';
import './styles/Billetterie.css';

const Billetterie = () => {
  const events = [
    {
      id: 4,
      name: 'Théâtre Solidaire - Samedi 21 Novembre 2026',
      date: '2026-11-21T19:00:00Z',
      description: `Dans un bistrot de village, rien ne va plus ! Pas un client en vue ! Les factures s'empilent et la caisse sonne creux ! Mais ce n'est que le calme avant la tempête... Entre révélations, mensonges et magouilles, le bistrot vire au joyeux chaos !`,
      price: '🎟️ 8 € (Gratuit pour les - de 12 ans) 🥪 3 €',
      helloAssoLink: 'https://www.helloasso.com/associations/amicale-laique-jules-ferry-59960-neuville-en-ferrain/evenements/representation-theatrale-le-bistrot-des-magouilles',
    },
    {
      id: 2,
      name: 'Théâtre Solidaire - Dimanche 22 Novembre 2026',
      date: '2026-11-22T14:30:00Z',
      description: `Dans un bistrot de village, rien ne va plus ! Pas un client en vue ! Les factures s'empilent et la caisse sonne creux ! Mais ce n'est que le calme avant la tempête... Entre révélations, mensonges et magouilles, le bistrot vire au joyeux chaos !`,
      price: '🎟️ 8 € (Gratuit pour les - de 12 ans) 🥪 3 €',
      helloAssoLink: 'https://www.helloasso.com/associations/amicale-laique-jules-ferry-59960-neuville-en-ferrain/evenements/representation-le-bistrot-des-magouilles',
    },
  ];

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Billetterie | Les Z'ineuvitables - Réservez vos places à Neuville-en-Ferrain</title>
        <meta
          name="description"
          content="Réservez vos places pour les événements théâtraux de la troupe amateur Les Z'Ineuvitables à Neuville-en-Ferrain. Soutenez des causes solidaires et profitez de spectacles uniques à la salle Malraux, à deux pas de Lille."
        />
        <meta
          name="keywords"
          content="billetterie, théâtre, événements, Neuville-en-Ferrain, solidarité, tickets, théâtre solidaire, troupe amateur, salle Malraux, spectacles, réservation en ligne"
        />
        <meta property="og:title" content="Billetterie | Les Z'ineuvitables - Réservez vos places à Neuville-en-Ferrain" />
        <meta
          property="og:description"
          content="Réservez vos places pour les événements théâtraux de la troupe amateur Les Z'Ineuvitables à Neuville-en-Ferrain. Soutenez des causes solidaires et profitez de spectacles uniques à la salle Malraux."
        />
        <meta property="og:url" content="https://www.zineuvitables.org/billetterie" />
        <meta property="og:image" content="https://www.zineuvitables.org/album/lebistrotdesmagouilles/bistrot.jpg" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="fr_FR" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Billetterie | Les Z'ineuvitables - Réservez vos places à Neuville-en-Ferrain" />
        <meta
          name="twitter:description"
          content="Réservez vos places pour les événements théâtraux de la troupe amateur Les Z'Ineuvitables à Neuville-en-Ferrain. Soutenez des causes solidaires et profitez de spectacles uniques à la salle Malraux."
        />
        <meta name="twitter:image" content="https://www.zineuvitables.org/album/lebistrotdesmagouilles/bistrot.jpg" />
      </Helmet>

      {/* CONTENEUR PRINCIPAL */}
      <div className="main-content-wrapper">
        
        {/* AFFICHE DE LA PIÈCE */}
        <div className="poster-container">
          <img
            src="/album/lebistrotdesmagouilles/bistrot.jpg"
            alt="Affiche de la pièce Le Bistrot des Magouilles"
            className="poster-image"
          />
        </div>
        
        {/* LISTE DES ÉVÉNEMENTS & BILLETS */}
        <div className="events-content-container"> 
          <h2 className="title">🎭 Billetterie - Choisissez votre événement</h2>
          
          <div className="events-list">
            {events.map((event) => (
              <div key={event.id} className="event-card">
                <FaTicketAlt style={{ fontSize: '2rem', color: '#007bff', marginBottom: '10px' }} />
                <h3>{event.name}</h3>
                <p>{new Date(event.date).toLocaleString('fr-FR', { dateStyle: 'full', timeStyle: 'short' })}</p>
                <p>{event.description}</p>
                <p><strong>{event.price}</strong></p>
                <a
                  href={event.helloAssoLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="payment-button"
                >
                  Accéder à la billetterie <FaExternalLinkAlt style={{ marginLeft: '8px' }} />
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Billetterie;